import type { Filters } from '../FiltersContext';
import type { IEvent } from '../../';

export const canFilterByEventType = (filters: Filters) => filters.selectedEventTypes.length > 0;

export const filterByEventType = (filters: Filters) => (event: IEvent) =>
	canFilterByEventType(filters)
		? Array.isArray(event.eventType) && event.eventType.some((type) => filters.selectedEventTypes.includes(type))
		: true;
